import moment from "moment";

import { QuestionnaireLinkConfiguration } from "@/Common/Components/Questionnaire/QuestionnaireLinkConfiguration";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";

import img_icon_attachment_icon from "@/Globals/_images/icons/attachment_icon.png";

class QuestionnaireStatusInfo {
    public QuestionnaireInstanceId: string;
    public AppointmentId: string;
    public AppointmentDate: Date;
    public QuestionnaireId: string;
    public Result: boolean;

    constructor(field?: Partial<QuestionnaireStatusInfo>) {
        Object.assign(this, field);
    }

    public get ShortName(): string {
        return cacheStore.getQuestionnaireShortName(this.QuestionnaireId);
    }

    public get Name(): string {
        return cacheStore.getQuestionnaireName(this.QuestionnaireId);
    }

    public get HasResult(): boolean {
        return this.Result !== null && this.Result !== undefined;
    }

    public get PdfPreviewUrl(): string {
        return apiSettings.buildAppUrl(
            "api/questionnaire/generatePdf",
            {
                auth: true,
                params: {
                    QuestionnaireInstanceId: this.QuestionnaireInstanceId
                }
            }
        );
    }

    public canBeRemoved(appointmentDate: Date): boolean {
        const currentDate = moment().toDate();
        return !this.HasResult
            && (
                isGuidNullOrUndefinedOrEmpty(this.QuestionnaireInstanceId)
                || moment(currentDate).isBefore(appointmentDate || this.AppointmentDate, "day")
            );
    }

    public shouldLinkBeActive(appointmentDate: Date, appointmentStatusLookupId: string, patientId: string, isPortalPatient: boolean): boolean {
        return QuestionnaireLinkConfiguration.shouldLinkBeActive(appointmentDate || this.AppointmentDate, appointmentStatusLookupId, this.HasResult, patientId, isPortalPatient, this.QuestionnaireInstanceId);
    }

    public renderLink(onClick?: (questionnaire: QuestionnaireStatusInfo) => void, appointmentDate?: Date, appointmentStatusLookupId?: string, patientId?: string, isPortalPatient?: boolean): JSX.Element {
        const isLinkActive = this.shouldLinkBeActive(appointmentDate, appointmentStatusLookupId, patientId, isPortalPatient);

        if (!this.HasResult)
            return this.renderResult(isLinkActive && onClick, "covid-noresult");

        if (this.Result === true)
            return this.renderResult(isLinkActive && onClick, "covid-positive", "glyphicon glyphicon-remove");

        if (this.Result === false)
            return this.renderResult(isLinkActive && onClick, "covid-negative", "glyphicon glyphicon-ok");
    }

    public isSubmittable(): boolean {
        if (!this.AppointmentDate)
            return false;

        let currentDate = moment();
        let oneDayBeforeAppointment = moment(this.AppointmentDate).add(-1, "day");
        return currentDate.isSame(oneDayBeforeAppointment, "day")
            || currentDate.isSame(this.AppointmentDate, "day");
    }

    public newInstance(): QuestionnaireStatusInfo {
        return new QuestionnaireStatusInfo({
            QuestionnaireInstanceId: GuidHelper.Empty(),
            QuestionnaireId: this.QuestionnaireId
        });
    }

    private renderPaperClip(): JSX.Element {
        return (
            <span>
                <img
                    className="paperClip-rotation"
                    src={img_icon_attachment_icon}
                    alt="paper clip icon"
                />
            </span>
        );
    }

    private renderResult(onClick?: (questionnaire: QuestionnaireStatusInfo) => void, className?: string, icon?: string): JSX.Element {
        return (
            <span className={className}>
                <a className={!!onClick ? "" : "not-allowed-hover"} onClick={() => onClick && onClick(this)}>
                    {this.renderPaperClip()} {this.ShortName} {!icon && "Ø"}<span style={{ verticalAlign: "text-top" }} className={icon} />
                </a>
            </span>
        );
    }
}

export { QuestionnaireStatusInfo };
